import React from 'react';
import ScenarioProduct from './ScenarioProduct';
import ReviewScenarioMapContainer from 'mapping/ReviewScenarioMapContainer';
import FieldCurvesTabs from './FieldCurvesTabs';
import ByZonesGraph from './ByZonesGraph';
import FieldAverageGraph from './FieldAverageGraph';
import AdvancedPlantingPlanFormContainer from 'planting-plan-form/AdvancedPlantingPlanFormContainer';

type ActiveScenarioSummaryWithDensityToolProps = {
  scenario: {
    product: {
      name: string;
      brand: string;
    };
  };
};

const ActiveScenarioSummaryWithDensityTool = ({ scenario }: ActiveScenarioSummaryWithDensityToolProps) => {
  const { product: { name, brand } } = scenario;

  return (
    <section className='active-scenario-summary-graphs'>
      <div>
        <ScenarioProduct name={name} brand={brand} />
        <ReviewScenarioMapContainer />
      </div>
      <FieldCurvesTabs>
        <FieldAverageGraph />
        <ByZonesGraph />
      </FieldCurvesTabs>
      <AdvancedPlantingPlanFormContainer />
    </section>
  );
};

export default ActiveScenarioSummaryWithDensityTool;
